import { lazy } from 'react';

export const MainSearchPageLazy = lazy(() => import('./MainSearchPage'));
